import { ALGOLIA_INDEX } from '@/config/constants';
import { createProxySearchClient } from '@/utils/api/algoliaSearchProxy';

export const SEARCH_DEBOUNCE_MS = 300;
const SEARCH_HITS = 8;

const entitySearchFacets = (types, excludeDepths) => [
    types.map((t) => `type:${t}`),
    ...(excludeDepths ?? []).map((d) => [`depth:-${d}`]),
];

/** Raw Algolia hits (`{ id, name, type, depth }`). Callers own their own
 * debounce and stale-response guard. */
export async function searchEntities({
    client,
    query,
    types,
    excludeDepths,
    hitsPerPage = SEARCH_HITS,
}) {
    const res = await client.search([
        {
            indexName: ALGOLIA_INDEX,
            params: {
                query,
                hitsPerPage,
                facetFilters: entitySearchFacets(types, excludeDepths),
            },
        },
    ]);
    return res?.results?.[0]?.hits ?? [];
}

export { createProxySearchClient };
